import { gql } from '@apollo/client';

export const REMOVE_ACCOUNT = gql`
  mutation RemoveAccount {
    removeAccount
  }
`;
